// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3cI94","icon_container":"Card_icon_container__32XhD","text_container":"Card_text_container__2goj_"};